import React from "react";

function InstagramIcon() {
  return (
    <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none" />
    </svg>
  );
}

function FacebookIcon() {
  return (
    <svg width="22" height="22" fill="currentColor" viewBox="0 0 24 24">
      <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
    </svg>
  );
}

function YoutubeIcon() {
  return (
    <svg width="22" height="22" fill="currentColor" viewBox="0 0 24 24">
      <path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.54C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58zM9.75 15.02V8.98L15.5 12l-5.75 3.02z" />
    </svg>
  );
}

const SOCIALS = [
  // { label: "Instagram", icon: <InstagramIcon />, href: "#" },
  { label: "Facebook", icon: <FacebookIcon />, href: "https://www.facebook.com/bizzyboxingllc" },
  // { label: "YouTube", icon: <YoutubeIcon />, href: "#" },
];

export function FooterRace() {
  return (
    <footer
      style={{
        background: "#000",
        borderTop: "2px solid #1E5EFF",
        padding: "4rem 1.5rem 3rem",
      }}
    >
      <div
        style={{
          maxWidth: 1400,
          margin: "0 auto",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 40,
          flexWrap: "wrap",
        }}
      >
        {/* Wordmark */}
        <div
          style={{
            fontFamily: "var(--font-display)",
            fontWeight: 900,
            fontStyle: "italic",
            textTransform: "uppercase",
            fontSize: "2rem",
            letterSpacing: "-0.02em",
          }}
        >
          <span style={{ color: "#fff" }}>Bizzy</span>
          <span style={{ color: "#1E5EFF" }}>Details</span>
        </div>

        {/* Social icons */}
        <div style={{ display: "flex", gap: 32 }}>
          {SOCIALS.map(({ label, icon, href }) => (
            <a
              key={label}
              href={href}
              aria-label={label}
              style={{ color: "rgba(255,255,255,0.35)", transition: "color 0.2s" }}
              onMouseEnter={e => ((e.currentTarget as HTMLElement).style.color = "#1E5EFF")}
              onMouseLeave={e => ((e.currentTarget as HTMLElement).style.color = "rgba(255,255,255,0.35)")}
            >
              {icon}
            </a>
          ))}
        </div>

        {/* Copyright */}
        <p
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: "0.6rem",
            color: "rgba(255,255,255,0.2)",
            textTransform: "uppercase",
            letterSpacing: "0.35em",
            fontWeight: 700,
          }}
        >
          © 2025 BIZZY DETAILS // PIT CREW EST.
        </p>
      </div>
    </footer>
  );
}
